module.exports = __webpack_public_path__ + "img/face-cowboy-hat.b2cf6895.svg";